<template>
  <b-card title="Parametrização de Permissões">
    <b-form>
      <div v-for="modulo in groupedModules" :key="modulo.key" class="mb-3">
        <h4 class="mb-0.5 mt-1 text-primary">Módulo</h4>
        <b-form-checkbox
          v-model="selectedPermissions"
          :value="modulo.key"
          @change="onModuloChange(modulo.key)"
          class="font-weight-bold"
          switch
          inline
          :disabled="!acesso.ConfiguracoesSistemaModulosEditar"
        >
          {{ modulo.label }}
        </b-form-checkbox>

        <h5 v-if="modulo.submodulos.length > 0" class="mb-0.5 mt-1">Sub-Módulos</h5>
        <b-row>
          <b-col v-for="sub in modulo.submodulos" :key="sub.key" cols="2">
            <b-form-checkbox
              v-model="selectedPermissions"
              :value="sub.key"
              :disabled="!selectedPermissions.includes(modulo.key) || !acesso.ConfiguracoesSistemaModulosEditar"
              @change="onSubModuleChange(modulo.key)"
              switch
              inline
            >
              {{ sub.label }}
            </b-form-checkbox>
          </b-col>
        </b-row>
      </div>

      <b-button variant="primary" @click="save" :disabled="!acesso.ConfiguracoesSistemaModulosEditar"
        >Salvar Permissões</b-button
      >
    </b-form>
  </b-card>
</template>

<script>
  import useJwt from '@/auth/jwt/useJwt'
  import { ModuleEnum } from '@/enums/module'

  export default {
    data() {
      return {
        selectedPermissions: [],
        userData: this.$jwtDecode(localStorage.getItem('userData')).userData,
        acesso: {
          ConfiguracoesSistemaModulosEditar: false,
        },
      }
    },
    props: {
      options: {
        type: Object,

        default: () => {},
      },
    },
    computed: {
      groupedModules() {
        const modulos = {}

        for (const chave in ModuleEnum) {
          if (!chave.includes('_')) {
            modulos[chave] = {
              key: chave,
              label: ModuleEnum[chave],
              submodulos: [],
            }
          }
        }

        for (const chave in ModuleEnum) {
          if (chave.includes('_')) {
            const [modulo] = chave.split('_')
            if (modulos[modulo]) {
              modulos[modulo].submodulos.push({
                key: chave,
                label: ModuleEnum[chave],
              })
            }
          }
        }

        return Object.values(modulos)
      },
    },

    mounted() {
      this.load()

      if (this.userData.role == 'master') {
        this.acesso.ConfiguracoesSistemaModulosEditar = true
      } else {
        this.acesso.ConfiguracoesSistemaModulosEditar = this.userData.GrupoAcesso.ConfiguracoesSistemaModulosEditar
      }
    },
    methods: {
      onModuloChange(moduloKey) {
        const submodulos = Object.keys(ModuleEnum).filter((key) => key.startsWith(moduloKey + '_'))

        if (!this.selectedPermissions.includes(moduloKey)) {
          this.selectedPermissions = this.selectedPermissions.filter((p) => !submodulos.includes(p))
        }
      },
      onSubModuleChange(moduloKey) {
        const submodulos = Object.keys(ModuleEnum).filter((key) => key.startsWith(moduloKey + '_'))

        const algumSelecionado = submodulos.some((sub) => this.selectedPermissions.includes(sub))

        if (!algumSelecionado) {
          this.selectedPermissions = this.selectedPermissions.filter((p) => p !== moduloKey)
        }
      },
      save() {
        const payload = {}

        Object.keys(ModuleEnum).forEach((key) => {
          payload[key] = this.selectedPermissions.includes(key)
        })

        useJwt
          .post('/modulos', payload)
          .then(() => {
            this.$message.success('Permissões salvas com sucesso!')
            this.$router.go()
          })
          .catch(() => {
            this.$message.error('Erro ao salvar permissões')
          })
      },
      async load() {
        try {
          this.selectedPermissions = Object.entries(this.options.ConfiguracaoModulos)
            .filter(([, value]) => value === true)
            .map(([key]) => key)

          this.selectedPermissions.forEach((permissao) => {
            if (permissao.includes('_')) {
              const modulo = permissao.split('_')[0]
              if (!this.selectedPermissions.includes(modulo)) {
                this.selectedPermissions.push(modulo)
              }
            }
          })
        } catch {
          this.$message.error('Erro ao carregar permissões dos módulos')
        }
      },
    },
  }
</script>

<style scoped>
  .font-weight-bold {
    font-weight: 600;
  }
</style>
